export default __webpack_public_path__ + "static/media/books2-afterA-768w.1f293525.webp";